module.exports = __webpack_public_path__ + "img/1.4c48a8ec.png";